import { render, staticRenderFns } from "./OtherOffers.vue?vue&type=template&id=bbbb9afe&"
import script from "./OtherOffers.vue?vue&type=script&lang=js&"
export * from "./OtherOffers.vue?vue&type=script&lang=js&"
import style0 from "./OtherOffers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports